import PropTypes from 'prop-types';
import React from 'react';

import cx from 'classnames';
import { Col } from 'react-bootstrap';
import ContactDetailsSlideview from "../../components/Contacts/ContactDetails/ContactDetailsSlideview.jsx"
import InfiniteScroll from 'react-infinite-scroller';
import StreamIcon from "./stream/StreamIcon";
import GroupSearchView from "./group/GroupSearchView";
import ContactView from "./contact/ContactView"
import ContactListView from "./contactList";

import styles from './styles.module.scss';

import CollectionSearchView from './collection/CollectionSearchView'

class SearchResultView extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      hasMore: this.props.hasMore,
      selectedContact:null
    }
    this.showContactsView = this.showContactsView.bind(this);
  }

  loadMoreItems(){
    if(this.props.loadMore){
      this.props.loadMore();
    }
  }

  componentWillReceiveProps(nextProps){
    if(this.props.hasMore != nextProps.hasMore){
      this.setState({
        hasMore: nextProps.hasMore
      });
    }
  }

  showContactsView(recipientContact){
    this.setState({
      selectedContact:recipientContact
    })
  }

  render() {
    return (
      <InfiniteScroll
        className={cx(styles.equalHeight, "row")}
        pageStart={0}
        initialLoad={false}
        hasMore={this.state.hasMore}
        loadMore={(page) => {this.loadMoreItems()}}
        useWindow = {false}
        threshold = {100}
        getScrollParent={() => this.props.containerRef && this.props.containerRef}
      >
        {this.renderItems()}
        <ContactDetailsSlideview onClose={()=>this.setState({selectedContact:null})} selectedContact={this.state.selectedContact} />
      </InfiniteScroll>
    );
  }


  renderItems(){
    var items = (this.props.items || []).map(item => {
    
      if(item.entityType == 'stream'){        
        return (
          <Col md={4}  className = {styles.paddingRight} key={ item.id }>
            <StreamIcon
              id={item.id}
              stream = {item}
              iconWidth={100}
            />

          </Col>
        );

      }else if(item.entityType == 'group'){
       
        return(
          <Col md={4} key={ item.id }>
            <GroupSearchView 
              id={item.id}
              group = {item} 
              iconWidth={100} 
            />
          </Col>
        );  

      }else if(item.entityType == 'collection'){
       
        return(
          <Col md={4} key={ item.id }>
            <CollectionSearchView 
              collection = {item} 
              iconWidth={130} 
            />
          </Col>
        );  

      }else if(item.entityType == 'contact'){
        return (
          <Col md={3} key={ item.id }>
            <ContactView className={styles.contact} contact={item}  showContactsView={this.showContactsView} />
          </Col>
        );
        
      } else if(item.entityType == 'contact_list'){
        return(
          <Col md={3} key={ item.id }>
            <ContactListView className={styles.contact} contactList={item} />
          </Col>
        )
      }

      return null;
    })

    return items;
  }
}

SearchResultView.contextTypes = {
  store: PropTypes.object.isRequired,
}

export default SearchResultView;